<template>
  <div class="content">
    <title-bar :title="$lang.Depósito"></title-bar>
    <!-- <van-nav-bar
      :title="$lang.Depósito"
      :border="false"
      @click-left="onClickLeft"
      fixed
      z-index="999"
    >
      <template #left>
        <van-icon name="arrow-left" size="20" color="#1F2A47" />
      </template>
    </van-nav-bar> -->

    <div style="padding: 20px 15px">
      <div class="depo_cont">
        <img
          src="../../../assets/img/recharge/qb_icon.png"
          style="
            position: absolute;
            right: 0;
            bottom: 0;
            width: 150px;
            z-index: -2;
          "
        />
        <div style="position: relative; z-index: 999">
          <!-- 倒计时状态（29:59 到 00:00） -->
          <div
            v-if="orderStatus == '0' && countdown > 0"
            style="
              background: #ffda47;
              border-radius: 32px;
              color: #000000;
              padding: 5px 0;
              width: 80%;
              margin: 0 auto;
              text-align: center;
            "
          >
            <p style="font-weight: 800">{{ $lang.common_txt248 }}</p>
            <p style="font-weight: 800; font-size: 20px">{{ timeCounmp }}</p>
          </div>

          <!-- 支付成功状态 -->
          <div
            v-if="orderStatus == '1'"
            style="
              background: #23b975;
              border-radius: 32px;
              color: #000000;
              width: 80%;
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              padding: 10px 0;
            "
          >
            <img src="../../../assets/img/recharge/sucee_sle.png" width="30" />
            <p class="m-l-10" style="font-weight: 800">
              {{ $lang.common_txt251 }}
            </p>
          </div>

          <!-- 倒计时结束或订单超时状态 -->
          <div
            v-if="(orderStatus == '0' && countdown <= 0) || orderStatus == '2'"
            style="
              background: #6e6e6e;
              border-radius: 32px;
              color: #000000;
              width: 80%;
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              padding: 10px 0;
            "
          >
            <img src="../../../assets/img/recharge/wait_sle.png" width="30" />
            <p class="m-l-10" style="font-weight: 800">
              {{ $lang.common_txt252 }}
            </p>
          </div>

          <div class="d-flex m-t-20" style="justify-content: center">
            <div class="d-flex">
              <img
                src="../../../assets/img/recharge/amount_icon.png"
                width="20"
              />
              <p class="m-l-10" style="color: #d1e7f5">
                {{ $lang.common_txt86 }}
              </p>
            </div>
          </div>
          <p
            style="
              color: #ffffff;
              text-align: center;
              font-size: 25px;
              font-weight: 700;
              margin-top: 10px;
            "
          >
            {{ $formatNumberWithCommas(infoDetail.paymentAmount) }}
            {{ infoDetail.paymentId }}
          </p>
          <p style="text-align: center; color: #ffffff">
            ({{ infoDetail.wlType }})
          </p>

          <div
            style="
              background: #ffffff;
              padding: 18px;
              border-radius: 15px;
              margin-top: 15px;
            "
            class="d-flex"
          >
            <vue-qr
              :text="infoDetail.url"
              :size="100"
              class="content-c3--qr"
              :margin="1"
            ></vue-qr>
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-flow: column;
                height: 100px;
                word-break: break-all;
              "
            >
              <p>{{ $lang.common_txt249 }}</p>
              <p
                style="
                  background: #f2f5fb;
                  border: 1px solid #040404;
                  border-radius: 8px;
                  padding: 5px;
                  color: #000000;
                "
              >
                {{ infoDetail.url }}
              </p>
              <div
                class="d-flex"
                style="
                  background: #3979e3;
                  padding: 6px 0;
                  border-radius: 8px;
                  color: #ffffff;
                  justify-content: center;
                "
                @click="copyText"
              >
                <img src="../../../assets/img/recharge/copy_i.png" width="15" />
                <p class="m-l-5">{{ $lang.common_txt250 }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="m-t-20 f-t-13 f-w" style="color: #ffffff">
          <p class="m-b-10">{{ $lang.common_txt253 }}</p>
          <p class="m-b-10">{{ $lang.common_txt254 }}</p>
          <p>{{ $lang.common_txt255 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import { UpayStatusorderNo } from '@/api/common'
export default {
  name: 'payOrder',
  components: { VueQr },
  data() {
    return {
      infoDetail: JSON.parse(sessionStorage.getItem('payOrderData')),
      timeCounmp: '29:59', // 初始倒计时
      orderStatus: '0', // 默认未支付状态
      countdown: 30 * 60, // 30分钟倒计时（秒）
      timer: null, // 倒计时定时器
      apiTimer: null, // 接口调用定时器
      startTime: null, // 页面首次加载时间（用于计算是否已过1分钟）
      isApiPollingStarted: false // 标记接口轮询是否已启动
    }
  },
  mounted() {
    // 初始化页面启动时间（优先从缓存读取，支持刷新后恢复）
    this.initStartTime()

    // 初始化倒计时
    this.initCountdown()

    // 检查是否需要启动接口轮询（支持刷新后恢复）
    this.checkAndStartApiPolling()
  },
  beforeRouteLeave(to, from, next) {
    // 路由离开时（退出当前页面），强制停止所有定时器和清理缓存
    this.forceStopAllTimersAndCache()
    next()
  },
  beforeDestroy() {
    // 组件销毁时，强制停止所有定时器和清理缓存（双重保障）
    this.forceStopAllTimersAndCache()
  },
  methods: {
    onClickLeft() {
      this.$jumpTo('/rechargeCont', {}, { replace: true })
    },
    copyText() {
      const textarea = document.createElement('textarea')
      textarea.value = this.infoDetail.url
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$toast({
        message: this.$lang.Sucesso,
        icon: 'success'
      })
    },
    // 初始化页面启动时间
    initStartTime() {
      const cacheKey = `startTime_${this.infoDetail.orderNo}`
      const cachedStartTime = sessionStorage.getItem(cacheKey)

      if (cachedStartTime) {
        // 从缓存恢复启动时间
        this.startTime = parseInt(cachedStartTime)
      } else {
        // 首次加载，记录当前时间戳
        this.startTime = Date.now()
        sessionStorage.setItem(cacheKey, this.startTime)
      }
    },
    // 初始化30分钟倒计时
    initCountdown() {
      const cacheKey = `countdown_${this.infoDetail.orderNo}`
      const remainingTime = sessionStorage.getItem(cacheKey)

      if (remainingTime) {
        // 从缓存中读取剩余时间（支持刷新后恢复）
        this.countdown = parseInt(remainingTime)
      } else {
        this.countdown = 30 * 60 // 30分钟
      }

      // 更新倒计时显示
      this.updateCountdownDisplay()

      // 启动倒计时定时器
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
          // 缓存剩余时间
          sessionStorage.setItem(cacheKey, this.countdown)
          this.updateCountdownDisplay()

          // 倒计时过程中检查是否需要启动接口轮询
          this.checkAndStartApiPolling()
        } else {
          // 倒计时结束，强制停止所有定时器和缓存
          this.forceStopAllTimersAndCache()
        }
      }, 1000)
    },
    // 更新倒计时显示格式（mm:ss）
    updateCountdownDisplay() {
      const minutes = Math.floor(this.countdown / 60)
      const seconds = this.countdown % 60
      this.timeCounmp = `${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`
    },
    // 检查是否需要启动接口轮询
    checkAndStartApiPolling() {
      // 已经启动过轮询、支付成功、倒计时结束，不需要再启动
      if (
        this.isApiPollingStarted ||
        this.orderStatus === '1' ||
        this.countdown <= 0
      ) {
        return
      }

      // 计算已经过了多少时间（毫秒）
      const elapsedTime = Date.now() - this.startTime
      const oneMinute = 60 * 1000 // 1分钟

      if (elapsedTime >= oneMinute) {
        // 已经过了1分钟，立即启动接口轮询
        this.startApiPolling()
      } else {
        // 还没到1分钟，设置定时器，到时间后启动
        setTimeout(() => {
          this.startApiPolling()
        }, oneMinute - elapsedTime)
      }
    },
    // 开始接口轮询（刷新后也能保持3秒一次）
    startApiPolling() {
      if (this.isApiPollingStarted) return

      this.isApiPollingStarted = true
      console.log('开始接口轮询，每3秒一次')

      // 先立即调用一次
      this.fetchOrderStatus()

      // 之后每3秒调用一次（刷新后会重新创建定时器，保持轮询）
      this.apiTimer = setInterval(() => {
        this.fetchOrderStatus()
      }, 3000)
    },
    // 调用订单状态接口
    async fetchOrderStatus() {
      try {
        const data = await UpayStatusorderNo({
          orderNo: this.infoDetail.orderNo
        })
        if (data.status === 'ok') {
          this.orderStatus = data.content.orderStatus
          console.log('订单状态更新：', data.content.orderStatus)

          // 订单支付成功或倒计时结束，停止接口调用
          if (this.orderStatus === '1' || this.countdown <= 0) {
            this.forceStopAllTimersAndCache()
          }
        }
      } catch (error) {
        console.error('获取订单状态失败：', error)
        // 接口调用失败不停止轮询，继续尝试
      }
    },
    // 强制停止所有定时器和清理缓存（退出页面时使用）
    forceStopAllTimersAndCache() {
      console.log('退出页面，停止所有定时器和清理缓存')
      // 清除倒计时定时器
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }

      // 清除接口轮询定时器
      if (this.apiTimer) {
        clearInterval(this.apiTimer)
        this.apiTimer = null
      }

      // 标记轮询已停止
      this.isApiPollingStarted = false

      // 清除所有相关缓存
      const orderNo = this.infoDetail?.orderNo
      if (orderNo) {
        sessionStorage.removeItem(`countdown_${orderNo}`)
        sessionStorage.removeItem(`startTime_${orderNo}`)
        sessionStorage.removeItem(`isApiPollingStarted_${orderNo}`)
        sessionStorage.removeItem(`orderStatus_${orderNo}`)
      }
    }
  },
  created() {
    // 页面创建时从缓存恢复关键状态（支持刷新后恢复）
    const orderNo = this.infoDetail?.orderNo
    if (orderNo) {
      const cachedIsPolling = sessionStorage.getItem(
        `isApiPollingStarted_${orderNo}`
      )
      const cachedStatus = sessionStorage.getItem(`orderStatus_${orderNo}`)

      if (cachedIsPolling !== null) {
        this.isApiPollingStarted = cachedIsPolling === 'true'
      }

      if (cachedStatus) {
        this.orderStatus = cachedStatus
      }
    }
  }
}
</script>
<style lang="less" scoped>
.depo_cont {
  background: #253b80;
  padding: 20px;
  position: relative;
  min-height: 320px;
  border-radius: 32px;
  z-index: 1;
}
.content-c3--qr {
  margin-right: 10px;
  border-radius: 8px;
  width: 100px;
  height: 100px;
}
</style>
